@defer (on timer(100ms)) {
    <section modalContainer invisibleWhitespace>
        <app-modal-header header (close)="close()">문서 추가</app-modal-header>
        <div
            class="flex md:min-w-[45rem] md:h-[40rem] w-full divide-x divide-gray-100"
        >
            <ng-container *ngTemplateOutlet="left" />
            <ng-container *ngTemplateOutlet="right" />
        </div>
        <div
            footer
            class="flex w-full justify-between p-4 border-t border-gray-100"
        >
            <app-button
                (click)="handleManageCategory()"
                color="gray"
                variant="outline"
                >카테고리 편집</app-button
            >
            <div class="flex gap-2 items-center">
                <app-button
                    (click)="handleAddDocumentTemplate()"
                    color="gray"
                    variant="outline"
                    >템플릿 등록</app-button
                >
                <app-button
                    [disabled]="
                        !fixDocumentTypes().length && !templateIds().length
                    "
                    (click)="addTemplate()"
                    >문서 추가</app-button
                >
            </div>
        </div>
    </section>

    <ng-template #left>
        <div class="w-[16.5rem] flex flex-col h-full bg-gray-50">
            <button
                [ngClass]="
                    isAll() ? 'bg-white *:text-gray-800' : '*:text-gray-400'
                "
                class="p-4 select-none text-left transition-colors"
                (click)="handleAll()"
            >
                <p class="text-sm">
                    전체 ({{
                        etcDocuments.length + totalTemplateCount() | number
                    }})
                </p>
            </button>
            <button
                [ngClass]="
                    fixDocumentCategory() === 'etc'
                        ? 'bg-white *:text-gray-800'
                        : '*:text-gray-400'
                "
                class="p-4 select-none text-left transition-colors"
                (click)="handleFixCategoryClick('etc')"
            >
                <p class="text-sm">
                    기타 문서 ({{ etcDocuments.length | number }})
                </p>
            </button>
            @for (c of categories(); track $index) {
                <button
                    [ngClass]="
                        categoryId() === c.id
                            ? 'bg-white *:text-gray-800'
                            : '*:text-gray-400'
                    "
                    class="p-4 select-none text-left transition-colors"
                    (click)="handleCategoryClick(c.id)"
                >
                    <p class="text-sm">
                        {{ c.name }} ({{ c.templateCount | number }})
                    </p>
                </button>
            }
        </div>
    </ng-template>

    <ng-template #right>
        <div class="flex flex-col w-full h-full bg-white overflow-y-auto">
            <div class="p-4">
                <app-input
                    [(value)]="query"
                    (valueChange)="handleChange()"
                    [debounce]="300"
                    placeholder="문서명을 검색해주세요."
                    icon="mdi:search"
                />
            </div>
            <div class="border-t border-gray-100 flex flex-col p-4 gap-3">
                @if (isAll() || fixDocumentCategory() === "etc") {
                    @for (service of etcDocuments; track $index) {
                        <div
                            animate.enter="fade-in"
                            (click)="handleFixDocumentClick(service)"
                            [ngClass]="
                                fixDocumentTypes().includes(service)
                                    ? 'border-primary bg-primary-50'
                                    : 'border-gray-100'
                            "
                            class="cursor-pointer flex gap-3 border rounded-xl p-4 transition-colors"
                        >
                            <div class="flex flex-col gap-2 w-full">
                                <div
                                    class="flex w-full justify-between items-center"
                                >
                                    <div class="flex gap-2 items-center">
                                        <div
                                            class="px-1.5 py-0.5 category-badge text-gray-800 text-xs"
                                        >
                                            기타 문서
                                        </div>
                                    </div>
                                </div>
                                <p class="">{{ service }}</p>
                                <div class="flex gap-2 items-center">
                                    <div
                                        class="px-1.5 text-white py-1 bg-[#7D9DB2] text-sm rounded-md"
                                    >
                                        기본
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                }
                @if (isAll() || categoryId()) {
                    @for (item of items(); track $index) {
                        <app-document-template-item
                            animate.enter="fade-in"
                            [active]="templateIds().includes(item.id)"
                            [item]="item"
                            (refresh)="handleRefresh()"
                            (checkedChange)="handleTemplateClick(item)"
                        />
                    }
                }
            </div>
        </div>
    </ng-template>
}
